import React from 'react';

export const ControlSidebar = () => {
  return <></>;
  /*return (
    <div className="space-y-2" style={{ position: 'fixed', right: '20px', bottom: '40vh', zIndex: 1000 }}>
      <Controls />
    </div>
  );*/
};
